import * as z from 'zod';
import { stripPostgresUnsafeControlChars } from '../../../../utils/sanitize-postgres-text.util.mjs';
import '../../../financial-formula/adjustable-value.mjs';
import '../../../financial-formula/adjustable-values-update.mjs';
import { Adjustment } from '../../../financial-formula/adjustment.mjs';
import '../../../financial-formula/formula.mjs';
import '@inrev/core';
import { currencySchema } from '../../../utils.mjs';

const lineItemLabelSchema = z
    .string({ error: "Line item label is required" })
    .transform(stripPostgresUnsafeControlChars)
    .pipe(z.string().trim().min(1, "Line item label is required"));
var LineItem;
(function (LineItem) {
    LineItem.schema = z.object({
        label: lineItemLabelSchema,
        value: currencySchema.optional(),
        adjustment: Adjustment.schema.nullish(),
        autoSource: z.string().optional(),
    });
})(LineItem || (LineItem = {}));
var LineItemGroup;
(function (LineItemGroup) {
    LineItemGroup.schema = z.object({
        total: currencySchema,
        lineItems: z.array(LineItem.schema),
    });
})(LineItemGroup || (LineItemGroup = {}));
const isLineItemGroup = (value) => typeof value === "object" &&
    value !== null &&
    "lineItems" in value &&
    Array.isArray(value.lineItems);

export { LineItem, LineItemGroup, isLineItemGroup, lineItemLabelSchema };
